<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'イベントの複製'">
        <template slot="content">
          <div class="text">
            <b>複製したいイベント</b>のメニュー「･･･」をタップし、<b>イベントを複製</b>で過去のイベントをコピーして作成することができます。
          </div>
          <img class="picture" src="../assets/images/features_admin/eventcopy.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesAdminCopyActivity.vue